import axios from 'src/utils/axios';
import { createSlice } from '@reduxjs/toolkit';
import EnumErrorCodes from 'src/utils/errors/EnumErrorCodes';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  hasError: false,
  printers: [],
  printer: null,
  createdSuccess: false,
  updatedSuccess: false,
  deletedSuccess: false
};

const slice = createSlice({
  name: 'printers',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.hasError = true;
    },

    // GET PRODUCTS
    getPrintersSuccess(state, action) {
      state.isLoading = false;
      state.printers = action.payload;
    },

    // GET PRODUCT
    getPrinterSuccess(state, action) {
      state.isLoading = false;
      state.printer = action.payload;
    },

    // ADD PRINTER
    addPrinterSuccess(state, action) {
      state.isLoading = false;
      state.printers = [...state.printers, action.payload];
    },

    getPrinterByID(state, action) {
      state.printer = state.printers.find((p) => p.id == action.payload);
    },

    selectedPrinterById(state, action) {
      state.printer = state.printers.find(
        (c) => Number(c.id) === Number(action.payload)
      );
    },

    updatePrinterSuccess(state, action) {
      state.isLoading = false;
      state.printer = action.payload;
      state.printers = state.printers.map((printer) => {
        if (printer.id == action.payload.id) return action.payload;
        else return printer;
      });
      state.updatedSuccess = true;
    },
    deletePrinterSuccess(state, action) {
      state.isLoading = false;
      state.printer = null;
      state.printers = state.printers.filter((p) => p.id !== action.payload);
      state.deletedSuccess = true;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getPrintersSuccess,
  getPrinterSuccess,
  getPrinterByID,
  selectedPrinterById,
  updatePrinterSuccess,
  deletePrinterSuccess,
  addPrinterSuccess
} = slice.actions;

// ----------------------------------------------------------------------

export function getPrinters() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const userId = window.localStorage.getItem('userId');
      const response = await axios.get(`printer/restaurante/${userId}`);
      dispatch(slice.actions.getPrintersSuccess(response.data.printers));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPrinter(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`printer/${id}`);
      dispatch(slice.actions.getPrintersSuccess(response.data.printer));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function AddPrinter(printer) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const userId = window.localStorage.getItem('userId');
      const response = await axios.post(
        `printer`,
        JSON.stringify({
          ...printer,
          idUser: userId
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
          }
        }
      );
      dispatch(slice.actions.addPrinterSuccess(response.data.printer));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function UpdatePrinter(printer) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const userId = window.localStorage.getItem('userId');
      const response = await axios.put(
        `printer`,
        JSON.stringify({
          ...printer,
          idUser: userId
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
          }
        }
      );
      dispatch(slice.actions.updatePrinterSuccess(response.data.printer));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
      if (error === EnumErrorCodes.EnumErrorCodes) {
      }
    }
  };
}

export function deletePrinter(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.delete(`printer/${id}`);
      dispatch(slice.actions.deletePrinterSuccess(id));
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
